import { v4 as uuidv4 } from "uuid";
import * as utils from "common/utils";
import actionTypes from "./_actions";

const _handleAdd = (offlineFarms, payload) => {
    const { farmId, budgetId, soilTests, blocks } = payload;

    if (soilTests.id === undefined || soilTests.id === null) soilTests.id = uuidv4();

    return offlineFarms.map((offlineFarm) => {
        if (offlineFarm.id !== farmId) return offlineFarm;

        return {
            ...offlineFarm,
            farm: {
                ...offlineFarm.farm,
                offlineBudgets: offlineFarm.farm.offlineBudgets.map((offlineBudget) => {
                    if (offlineBudget.id !== budgetId) return offlineBudget;

                    return {
                        ...offlineBudget,
                        isDirty: true,
                        budget: {
                            ...offlineBudget.budget,
                            soilTests: utils.merge(soilTests, offlineBudget.budget.soilTests),
                            blocks: offlineBudget.budget.blocks.map((block) => {
                                return {
                                    ...block,
                                    soilTestId: blocks.some((b) => b.id === block.id) ? soilTests.id : block.soilTestId === soilTests.id ? null : block.soilTestId,
                                };
                            }),
                        },
                    };
                }),
            },
        };
    });
};

const _handleDelete = (offlineFarms, payload) => {
    const { farmId, budgetId, soilTestsId } = payload;

    return offlineFarms.map((offlineFarm) => {
        if (offlineFarm.id !== farmId) return offlineFarm;

        return {
            ...offlineFarm,
            farm: {
                ...offlineFarm.farm,
                offlineBudgets: offlineFarm.farm.offlineBudgets.map((offlineBudget) => {
                    if (offlineBudget.id !== budgetId) return offlineBudget;

                    return {
                        ...offlineBudget,
                        isDirty: true,
                        budget: {
                            ...offlineBudget.budget,
                            soilTests: offlineBudget.budget.soilTests.filter((t) => t.id !== soilTestsId),
                            blocks: offlineBudget.budget.blocks.map((block) => {
                                return {
                                    ...block,
                                    soilTestId: block.soilTestId === soilTestsId ? null : block.soilTestId,
                                };
                            }),
                        },
                    };
                }),
            },
        };
    });
};

function reducer(state = [], action) {
    let offlineFarms = state;
    if (!Array.isArray(state)) {
        offlineFarms = Object.keys(state).map((item) => state[item]);
    }

    switch (action.type) {
        case actionTypes.SOIL_TEST_ADD:
            return _handleAdd(offlineFarms, action.payload);
        case actionTypes.SOIL_TEST_DELETE:
            return _handleDelete(offlineFarms, action.payload);
        default:
            return offlineFarms;
    }
}

export default reducer;
